import Button from "@/design-system/button";

import type { OmitStyles } from "../../styles/tokens.stylex";

export function CloseIconSlimButton({
    styleX,
    strokeWidth = 4,
    type = "button",
    ...rest
}: OmitStyles<React.ButtonHTMLAttributes<HTMLButtonElement>> & {
    strokeWidth?: number;
}) {
    return (
        <Button as="button" {...rest} styleX={styleX} type={type} variant="none" size="None">
            {CloseIconSvg(strokeWidth)}
        </Button>
    );
}

export function CloseIconSvg(strokeWidth: number = 4) {
    return (
        <svg strokeWidth={strokeWidth}>
            <use xlinkHref="#closeIconSlim" />
        </svg>
    );
}
